import React from "react";
import {defineBlock,smartProps,ChildrenBlock, useEditor, useSmartProp, useToolbar, ColorToolbarButton} from "@smartfire/wordpress-react";
import { InnerBlocks } from '@wordpress/block-editor';
import style from "./block.module.scss";
import colorsconfig from "../shared/colorPalette";

function Toolbar() {
    const [backgroundColor, setBackgroundColor] = useSmartProp("backgroundColor");
    const colors = colorsconfig;
    return <>
            {colors && backgroundColor && <ColorToolbarButton colors={colors} color={backgroundColor} setColor={(c) => c ? setBackgroundColor(c) : null} />}
        </>
}

function Block({backgroundColor}){

    useToolbar(Toolbar);
    const {isEditing} = useEditor();

    return <div className={isEditing ? style.blockAdmin : style.block} style={{backgroundColor: backgroundColor}}>
                <div className={style.content}>
                    { isEditing ?<>
                            <div className={style.innerBlocks}>
                                <InnerBlocks allowedBlocks={["smartfire/logo-texte-item"]}  orientation="horizontal"/>
                            </div >
                    </>:
                    <ChildrenBlock  /> 
                    }
                    </div>
            </div>
}

export default defineBlock({
    Block,
    smartProps: {
        backgroundColor: smartProps.string.withDefault(style.blueBack),
    },
    setup: {
        title: "Logo + texte",
    }
});
